var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpencv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-69.65 120.638a139.301 139.301 120 1 1 139.301 0L27.71 47.993a55.418 55.418 120 1 0-55.418 0z",
    id: "A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.275322 0 0 1.275322 -38.047246 -14.965624)"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.063405 0 0 .063405 29.66229 12.95855)",
    y: 140,
    x: 298,
    xlinkHref: "#A",
    fill: "#ff0101"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.063405 0 0 -.063405 87.614835 65.58504)",
    y: 415,
    x: 457,
    xlinkHref: "#A",
    fill: "#0101ff"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.031703 -.054911 .054911 -.031703 20.379704 60.225737)",
    y: 415,
    x: 142,
    xlinkHref: "#A",
    fill: "#01ff01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpencv);
export default __webpack_public_path__ + "static/media/opencv.8ddaa43a5dcbf6b8dcc04ed8d571099e.svg";
export { ForwardRef as ReactComponent };